import { Admin } from '../../types/auth.types';
import { User } from '../../components/Tables';

/**
 * Format date to relative time
 */
export const formatRelativeTime = (dateString: string): string => {
  const date = new Date(dateString);
  const now = new Date();
  const diffInSeconds = Math.floor((now.getTime() - date.getTime()) / 1000);

  if (diffInSeconds < 60) return 'Just now';
  if (diffInSeconds < 3600) {
    const minutes = Math.floor(diffInSeconds / 60);
    return `${minutes} ${minutes === 1 ? 'minute' : 'minutes'} ago`;
  }
  if (diffInSeconds < 86400) {
    const hours = Math.floor(diffInSeconds / 3600);
    return `${hours} ${hours === 1 ? 'hour' : 'hours'} ago`;
  }
  if (diffInSeconds < 604800) {
    const days = Math.floor(diffInSeconds / 86400);
    return `${days} ${days === 1 ? 'day' : 'days'} ago`;
  }
  if (diffInSeconds < 2592000) {
    const weeks = Math.floor(diffInSeconds / 604800);
    return `${weeks} ${weeks === 1 ? 'week' : 'weeks'} ago`;
  }
  const months = Math.floor(diffInSeconds / 2592000);
  return `${months} ${months === 1 ? 'month' : 'months'} ago`;
};

/**
 * Transform API admin data to User format for the table
 */
export const transformAdminToUser = (admin: Admin, currentUserEmail?: string): User => {
  return {
    adminId: admin.adminId,
    name: admin.name,
    email: admin.email,
    lastActive: admin.lastActive ? formatRelativeTime(admin.lastActive) : 'Pending',
    status: admin.status === 'active' ? null : admin.status,
    role: admin.role === 'super_admin' ? 'superadmin' : undefined,
    isYou: currentUserEmail ? admin.email === currentUserEmail : false,
  };
};

/**
 * Filter admins based on search query and active tab
 */
export const filterAdmins = (
  users: User[],
  searchQuery: string,
  activeTab: 'all' | 'active' | 'suspended'
): User[] => {
  return users.filter(user => {
    const matchesSearch = user.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
                         user.email.toLowerCase().includes(searchQuery.toLowerCase());
    
    if (activeTab === 'all') return matchesSearch;
    if (activeTab === 'active') return matchesSearch && (user.status === null || user.status === 'active');
    if (activeTab === 'suspended') return matchesSearch && user.status === 'suspended';
    
    return false;
  });
};

